import { useEffect, useState } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import { API, DEFAULT_SITE } from "./components/site/api";
import Navbar from "./components/site/Navbar";
import Hero from "./components/site/Hero";
import Marquee from "./components/site/Marquee";
import Manifesto from "./components/site/Manifesto";
import Gallery from "./components/site/Gallery";
import Coverage from "./components/site/Coverage";
import Footer from "./components/site/Footer";
import AdminPage from "./components/site/AdminPage";
import axios from "axios";

const setMeta = (selector, value) => {
  const node = document.querySelector(selector);
  if (node && value) node.setAttribute("content", value);
};

const HomePage = () => {
  const [site, setSite] = useState(DEFAULT_SITE);

  useEffect(() => {
    axios.get(`${API}/site`).then(({ data }) => setSite(data)).catch(() => null);
  }, []);

  useEffect(() => {
    const { settings } = site;
    document.title = `${settings.company_name} | Installation & Refinishing PA, DE, NJ`;
    setMeta('meta[name="description"]', `${settings.company_name} provides hardwood flooring installation, refinishing, repair, trim, and millwork across Pennsylvania, Delaware, and New Jersey. Call ${settings.phone}.`);
    setMeta('meta[property="og:title"]', `${settings.company_name} | Floors with a point of view`);
    setMeta('meta[property="og:description"]', settings.tagline);
    setMeta('meta[property="og:image"]', settings.logo_url);
    setMeta('meta[name="twitter:title"]', settings.company_name);
    setMeta('meta[name="twitter:image"]', settings.logo_url);
    let schema = document.getElementById("sosas-business-schema");
    if (!schema) {
      schema = document.createElement("script");
      schema.id = "sosas-business-schema";
      schema.type = "application/ld+json";
      document.head.appendChild(schema);
    }
    schema.textContent = JSON.stringify({ "@context": "https://schema.org", "@type": "HomeAndConstructionBusiness", name: settings.company_name, telephone: `+1-${settings.phone}`, priceRange: "$$$", serviceType: ["Hardwood flooring installation", "Hardwood floor refinishing", "Hardwood floor repair", "Trim and millwork"], areaServed: ["Pennsylvania", "Delaware", "New Jersey"] });
  }, [site]);

  return (
    <div className="site-shell" id="top">
      <Navbar settings={site.settings} />
      <main>
        {site.settings.announcement_active && (
          <div className="announcement" data-testid="announcement-banner">
            <span className="signal-dot" />
            <span>{site.settings.announcement}</span>
            <a href={`tel:${site.settings.phone.replace(/[^0-9+]/g, "")}`} data-testid="announcement-phone-link">Call {site.settings.phone}</a>
          </div>
        )}
        <Hero settings={site.settings} />
        <Marquee phone={site.settings.phone} />
        <Manifesto settings={site.settings} gallery={site.gallery} />
        <Gallery gallery={site.gallery} />
        <Coverage settings={site.settings} />
        <section className="closing-section section-wrap" id="contact" data-testid="contact-section">
          <div className="closing-copy">
            <p className="eyebrow">Get an estimate</p>
            <h2>Need help with your floors?</h2>
            <p>Call or text for an estimate. Send photos of your rooms if you have them.</p>
          </div>
          <div className="closing-actions">
            <a className="button button-primary" href={`tel:${site.settings.phone.replace(/[^0-9+]/g, "")}`} data-testid="closing-call-button">Call {site.settings.phone}</a>
            <a className="button button-outline" href={`sms:${site.settings.phone.replace(/[^0-9+]/g, "")}`} data-testid="closing-text-button">Text for an estimate</a>
          </div>
        </section>
      </main>
      <Footer settings={site.settings} />
    </div>
  );
};

const App = () => (
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/admin" element={<AdminPage />} />
    </Routes>
    <Toaster position="bottom-right" toastOptions={{ className: "site-toast" }} />
  </BrowserRouter>
);

export default App;
